export const stateModal = {
    modalOpen: false,
    modalResultOpen: false,
    modalResultType: 'success',
    modalContent: '',
    modalIframeOpen: false,
}
